module.exports = new __parcel__URL__("filter-results-issue-table-skeleton.tpl.a502204a.svg").toString();